export default __webpack_public_path__ + "static/media/doctor.sprite.9cb0cc2b02cdfff072a5f86feb844fb3.svg";